<template>
  <base-modal form title="Reimburse Deposit" body-class="is-paddingless">
    <notification class="is-secondary is-radiusless is-marginless">
      Please supply the <a>date</a> and <a>time</a> of reimbursement.
    </notification>
    <div class="columns is-multiline p-2">
      <div class="column is-12">
        <date-picker required
          time
          v-model="deposit.paid_out"
          :error="errors.paid_out"
          error-class="has-text-danger">
          <static-button slot="left">Payment Date</static-button>
        </date-picker>
      </div>
    </div>
    <div slot="footer" class="buttons">
      <submit-button
        :working="working"
        @submit="save"
        class="is-success is-rounded">
        Save
      </submit-button>
    </div>
  </base-modal>
</template>

<script>
import { captureReimbursement } from '@/api/deposit'

export default {

  props: {
    payload: Object
  },

  data:() => ({
    working: false,
    deposit: {}
  }),

  created() {
    this.deposit = { ...this.payload }
  },

  methods: {
    save() {
      this.working = true
      captureReimbursement(this.deposit, () => {
        this.$toast.success('Reimbursement saved.')
        this.working = false
        this.$close(true)
      }, () => {
        this.working = false
      })
    }
  }

}
</script>